module.exports = __webpack_public_path__ + "static/media/icon-star.99f4417d.svg";